import { useTranslation } from 'react-i18next';

export function useI18n() {
  const { t, i18n } = useTranslation();

  return {
    t,
    lang: i18n.language,
    changeLanguage: i18n.changeLanguage.bind(i18n),
  };
}
